import React from "react";
import ComingSoon from "../Common/ComingSoon.jsx";

const ProgramEventsPage = () => <ComingSoon />;

export default ProgramEventsPage;

